import { Component, Vue } from 'vue-property-decorator'
import { getWorkOrderOver, setWorkOrderStatus, queryEvaluationIdl } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
@Component({ name: 'approveDetailClassover' })
export default class ApproveDetailClassover extends Vue {
  private rejectDialogVisible = false
  private rejectReason = ''
  private pageData = {}
  private loading = false
  private orderId: any = null
  private pageDataProgres: any = null
  private time: any = null
  created () {
    this.orderId = this.$route.query.id
    this.initPageData()
    if (this.$route.query.classId) {
      this.getEvaluationIdl()
    }
  }

  // 初始化页面数据
  private async initPageData () {
    const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
    this.loading = true
    this.pageData = await getWorkOrderOver({ id: this.orderId })
    this.loading = false
    loading.close()
  }

  private async getEvaluationIdl () {
    const result: any = await queryEvaluationIdl({ classId: this.$route.query.classId })
    this.pageDataProgres = result
  }

  private onRejectClick () {
    // 驳回
    this.rejectDialogVisible = false
  }

  private async onDoClick () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      await setWorkOrderStatus({ id: this.orderId, status: 2, comment: this.rejectReason })
      this.$message({ message: '操作成功', type: 'success' })
      this.rejectDialogVisible = false
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }, 400)
  }

  private async onSuccessClick () {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      await setWorkOrderStatus({ id: this.orderId, status: 1 })
      this.$message({ message: '操作成功', type: 'success' })
      TagsViewModule.delView(this.$route)
      this.$router.go(-1)
    }, 400)
  }
}
